import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function SuccessMedal(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "SuccessMedal", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.light,
        d: "M44.25 24c0 1.514-1.544 2.84-1.855 4.257-.322 1.468.514 3.318-.103 4.644-.631 1.35-2.59 1.901-3.489 3.066-.906 1.177-.94 3.21-2.08 4.153-1.138.942-3.14.593-4.468 1.258-1.313.656-2.236 2.47-3.694 2.813-1.414.334-3.047-.868-4.561-.868-1.514 0-3.15 1.2-4.561.868-1.459-.343-2.381-2.157-3.694-2.814-1.329-.664-3.33-.315-4.47-1.258-1.139-.943-1.173-2.976-2.08-4.152-.906-1.176-2.857-1.713-3.487-3.066-.617-1.326.22-3.176-.103-4.643C5.296 26.84 3.75 25.514 3.75 24c0-1.514 1.544-2.84 1.856-4.257.321-1.468-.515-3.318.102-4.644.631-1.35 2.59-1.901 3.489-3.066.906-1.177.94-3.21 2.08-4.153 1.138-.942 3.14-.593 4.468-1.257 1.313-.657 2.236-2.471 3.694-2.814 1.411-.334 3.047.868 4.561.868 1.514 0 3.15-1.2 4.561-.868 1.459.343 2.381 2.157 3.694 2.814 1.328.664 3.33.315 4.47 1.258 1.139.943 1.172 2.976 2.08 4.152.9 1.165 2.857 1.713 3.487 3.066.617 1.326-.22 3.176.102 4.643.312 1.418 1.856 2.744 1.856 4.258Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M24 38.25c7.87 0 14.25-6.38 14.25-14.25S31.87 9.75 24 9.75 9.75 16.13 9.75 24 16.13 38.25 24 38.25Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M21.293 31.1a1.47 1.47 0 0 1-.994-.396l-5.646-5.634a1.399 1.399 0 0 1 0-1.963 1.406 1.406 0 0 1 1.968 0l4.672 4.66 10.14-10.115a1.406 1.406 0 0 1 1.968 0 1.399 1.399 0 0 1 0 1.963L22.267 30.723c-.258.258-.616.377-.974.377Z"
      }
    )
  ] });
}
SuccessMedal.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "SuccessMedal"
};
validateTidalLicense();
export {
  SuccessMedal
};
//# sourceMappingURL=SuccessMedal.js.map
